import React from 'react'

const Arrow = () => {
    return (
        <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUuNjQxIiBoZWlnaHQ9IjkuMTY4IiB2aWV3Qm94PSIwIDAgMTUuNjQxIDkuMTY4Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIwLjk0OCIgeTE9IjAuNSIgeDI9IjAiIHkyPSIwLjUiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM3OGQ4ZmYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM0Y2UwOTYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBkPSJNMTIuMDM1LDEwLjEyOWw0LjU4NC00LjU4NEwxMi4wMzUuOTYyLDExLjAxMSwxLjk3NiwxMy44NCw0LjhILjk3OVY2LjI4NkgxMy44NEwxMS4wMTEsOS4xMDVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC45NzkgLTAuOTYyKSIgZmlsbD0idXJsKCNhKSIvPjwvc3ZnPg=="
            alt=""
        />
    )
}

export default Arrow
